import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import apiClient from "../api/client";
import { getAllCategoryPaths } from "../api/endpoints";
import { extractProducts } from "../services/productService";
import "leaflet/dist/leaflet.css";
import arrow from "../assets/arrow-up-right-black.svg";
import arrowdown from "../assets/arrow-down-simple.png";
import eye from "../assets/eye-svgrepo-com (2).svg";

const CustomerProductSection = () => {
  const [openItems, setOpenItems] = useState({});
  const [topProducts, setTopProducts] = useState([]);

  const fetchTopProducts = async () => {
    try {
      const responses = await Promise.all(
        getAllCategoryPaths().map((path) => apiClient.get(path))
      );
      const allProducts = responses.flatMap((res) => extractProducts(res.data) || []);

      const top = allProducts
        .map(p => ({
          ...p,
          rentalFee: Number(p.rentalFee) || 0,
          rating: Number(p.rating) || 0
        }))
        .sort((a, b) => b.rentalFee - a.rentalFee)
        .slice(0, 4);

      setTopProducts(top);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchTopProducts();
  }, []);

  return (
    <div className="flex flex-col md:flex-row gap-6 mb-6 w-full min-w-[350px] flex-1">
      {/* Customer Growth */}
      <div className="bg-white rounded-[24px] w-full lg:max-w-[40%] md:h-[400px] h-auto p-6 shadow flex-1 dark:bg-[#1A1A1B] dark:border dark:border-[#3D3D3D]">
        <div className="flex justify-between items-center">
          <h2 className="font-semibold text-[16px] text-gray-800 dark:text-gray-200">
            Customer Growth
          </h2>
          <Link to="/sales">
            <span className="text-sm text-black cursor-pointer hover:underline dark:text-gray-200">
              Show All
            </span>
            <img src={arrow} alt="" className="inline-block w-5 h-5" />
          </Link>
        </div>
        <p className="text-black text-sm mb-4 dark:text-gray-200">3 Province</p>

        {/* Legend */}
        <div className="flex flex-wrap gap-4 mb-5 text-xs">
          <div className="flex items-center gap-2 dark:text-gray-200">
            <span className="w-3 h-3 rounded-full bg-green-500"></span>
            <span className="text-gray-500 dark:text-gray-400">East Java</span>(50%)
          </div>
          <div className="flex items-center gap-2 dark:text-gray-200">
            <span className="w-3 h-3 rounded-full bg-blue-500"></span>
            <span className="text-gray-500 dark:text-gray-400">Kalimantan</span>(50%)
          </div>
          <div className="flex items-center gap-2 dark:text-gray-200">
            <span className="w-3 h-3 rounded-full bg-yellow-500"></span>
            <span className="text-gray-500 dark:text-gray-400">Bali</span>(65%)
          </div>
        </div>

        {/* Map */}
        <div className="relative w-full h-[250px] md:h-[260px] rounded-lg overflow-hidden border border-gray-200">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d59623193.96413057!2d11.044971032545764!3d24.20289315004592!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2seg!4v1757688106818!5m2!1sen!2seg"
            width="100%"
            height="100%"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>

      {/* Product Popular - Desktop */}
      <div className="hidden sm:block dark:bg-[#1A1A1B] dark:border-[#3D3D3D] bg-white flex flex-col items-start p-[20px] gap-6 w-full lg:max-w-[60%] max-h-[400px] border border-[#E7E7E7] rounded-[24px] shadow-md">
        <div className="flex gap-6 pb-6 justify-between items-center w-full">
          <h2 className="font-semibold text-[16px] text-gray-800 dark:text-gray-200">
            Top Products
          </h2>
          <Link to="/products">
            <span className="text-sm text-black cursor-pointer hover:underline dark:text-gray-200">
              Show All
            </span>
            <img src={arrow} alt="" className="inline-block w-5 h-5" />
          </Link>
        </div>

        <div className="overflow-hidden rounded-xl border border-gray-300 dark:border-[#3D3D3D] shadow-md">
          <table className="min-w-full bg-white border border-[#E7E7E7] rounded-xl shadow-md overflow-hidden dark:bg-[#1A1A1B] dark:border">
            <thead className="bg-gray-100 border-b border-[#E7E7E7] dark:bg-black dark:border-[#3D3D3D]">
              <tr>
                <th className="text-left px-4 py-4 text-black text-sm font-medium dark:text-gray-300">Product</th>
                <th className="text-left px-4 py-3 text-black text-sm font-medium dark:text-gray-300">Rental Fee</th>
                <th className="text-left px-4 py-3 text-black text-sm font-medium dark:text-gray-300">Vendor</th>
                <th className="text-left px-4 py-3 text-black text-sm font-medium dark:text-gray-300">Category</th>
                <th className="text-left px-4 py-3 text-black text-sm font-medium dark:text-gray-300">Rating</th>
                <th className="text-left px-4 py-3 text-black text-sm font-medium dark:text-gray-300">Actions</th>
              </tr>
            </thead>
            <tbody>
              {topProducts.map((p, index) => (
                <tr
                  key={p.id || index}
                  className="border-b border-gray-200 hover:bg-gray-50 dark:hover:bg-[#2D2D2D] dark:border-[#3D3D3D]"
                >
                  <td className="flex items-center gap-3 px-4 py-3 whitespace-nowrap text-gray-800 text-sm dark:text-gray-300">
                    <img
                      src={p.imageCover}
                      alt={p.name}
                      className="w-10 h-10 object-cover rounded-xl"
                    />
                    <div>
                      <p className="text-xs text-gray-500">{p.id}</p>
                      <p className="font-semibold">{p.name}</p>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-gray-900 font-semibold text-sm dark:text-gray-300">
                    ${p.rentalFee.toFixed(2)}
                  </td>
                  <td className="px-4 py-3 text-gray-900 font-semibold text-sm dark:text-gray-300">
                    {p.vendorName}
                  </td>
                  <td className="px-4 py-3 text-gray-900 font-semibold text-sm dark:text-gray-300">
                    {p.Category}
                  </td>
                  <td className="px-4 py-3 text-gray-900 font-semibold text-sm dark:text-gray-300">
                    {p.rating}
                  </td>
                  <td className="px-4 py-3 text-gray-900 font-semibold text-sm dark:text-gray-300">
                    <Link to={`/products/view-product/${p.id}`} state={{ product: p }}>
                      <img src={eye} alt="eye" className="w-5 h-5 inline" />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile view */}
      <div className="sm:hidden bg-white dark:bg-[#1A1A1B] flex flex-col items-start p-[20px] gap-6 w-full h-auto flex-1 border border-[#E7E7E7] dark:border-[#3D3D3D] rounded-[24px] shadow-md">
        <div className="flex gap-6 justify-between items-center w-full">
          <h2 className="font-semibold text-[16px] text-gray-800 dark:text-gray-200">Top Products</h2>
          <Link to="/products">
            <span className="text-sm text-black cursor-pointer hover:underline dark:text-gray-200">Show All</span>
            <img src={arrow} alt="" className="inline-block w-5 h-5"/>
          </Link>
        </div>

        <div className="w-full rounded-2xl h-auto border border-gray-200 dark:border-[#3D3D3D]">
          <div className="bg-gray-100 rounded-2xl border-b py-2 border-gray-300 px-4 text-black text-sm font-medium dark:bg-black dark:text-gray-200 dark:border-[#3D3D3D]">
            Product
          </div>

          {topProducts.map((p, index) => (
            <div key={p.id || index} className="relative border-b border-gray-200 dark:border-[#3D3D3D]">
              <div className="flex justify-between items-center py-3 px-4">
                <div className="flex gap-3 items-center">
                  <img src={p.images?.[0] || p.imageCover} alt={p.name} className="w-10 h-10 object-cover rounded-xl" />
                  <div>
                    <p className="text-xs text-gray-500 dark:text-gray-400">{p.id}</p>
                    <p className="font-semibold text-gray-800 dark:text-gray-200">{p.name}</p>
                  </div>
                </div>
                {/* السهم بيفتح صفحة المنتج */}
                <Link to={`/products/view-product/${p.id}`} state={{ product: p }}>
                  <img src={eye} alt="toggle" className="w-5 h-5 " />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CustomerProductSection;
